import React, { useState } from "react";
import "../../pages/answers/answer.css";
import { useDropzone } from "react-dropzone";
import { toast } from "react-toastify";
import RecordedAnswersAddModal from "./RecordedAnswersAddModal";

const RecordedAnswers = (props) => {
  const { answers, characters = [] } = props;

  const [activeIndex, setActiveIndex] = useState(null);
  const [activeAnswer, setActiveAnswer] = useState({});

  const { isDragActive, isDragAccept, isDragReject } = useDropzone();

  let dropzoneClass = "dropzone";
  if (isDragActive) dropzoneClass += " dropzone-active";
  if (isDragAccept) dropzoneClass += " dropzone-accept";
  if (isDragReject) dropzoneClass += " dropzone-reject";

  const handleIconClick = (index, answer) => {
    if (index === activeIndex) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  const deleteAnswer = async (id) => {
    try {
      if (window.confirm("Are you sure you want to delete answer ??")) {
        const response =  null;
        if (response) {
          toast.success("Deleted");
          window.location.reload();
        }
      }
    } catch (error) {}
  };

  return (
    <>
      <div className="data-table activityTable mt-5">
        <div className="tableStyle">
          <table>
            <thead>
              <tr>
                <th className="users-th">No</th>
                <th className="users-th">Character</th>
                <th className="users-th">Location</th>
                <th className="users-th">Recording</th>
                <th className="users-th">Action</th>
              </tr>
            </thead>
            <tbody>
              {answers.map((answer, index) => {
                if (!answer.audio) return null;

                const q =
                  answer?.questions_list?.questions.find(
                    (q) => q._id == answer.question
                  ) || {};

                return (
                  <tr>
                    <td className="users-td" key={index}>
                      {index + 1}
                    </td>
                    <td className="users-td">
                      <div className="d-flex align-items-center justify-content-center gap-2">
                        <img
                          className="character"
                        />
                        <div>{answer.character?.nameOfFamilyMember}</div>
                      </div>
                    </td>
                    <td className="users-td">
                      <div className="d-flex align-items-center justify-content-center gap-1">
                        {answer.story?.title}
                        <ion-icon
                          name="arrow-forward-outline"
                          font-size={30}
                        ></ion-icon>
                        {q?.title}{" "}
                        <ion-icon name="arrow-forward-outline"></ion-icon>
                        {answer.position}
                      </div>
                    </td>
                    <td className="users-td" style={{ width: "25%" }}>
                    </td>
                    <td className="users-td" style={{ width: "122px" }}>
                      <ion-icon
                        name="ellipsis-vertical-outline"
                        id="userAction"
                        onClick={() => handleIconClick(index)}
                        style={{ cursor: "pointer" }}
                      ></ion-icon>
                      {activeIndex === index && (
                        <div className="showOption-story">
                          {/* <NavLink
                            to={`/view-answer/${answer._id}`}
                            className="removeTextDecoration"
                          >
                            <p className="pt-3 d-flex align-items-center gap-2">
                              <ion-icon name="eye-outline"></ion-icon> View
                            </p>
                          </NavLink> */}
                          {/* <p
                            className="d-flex align-items-center gap-2 mt-2"
                            data-bs-target="#editModal"
                            data-bs-toggle="modal"
                            onClick={() => setActiveAnswer(answer)}
                          >
                            <ion-icon name="create-outline"></ion-icon> Edit
                          </p> */}
                          <p
                            className="d-flex align-items-center gap-2 mt-2"
                            style={{ color: "red" }}
                            onClick={() => deleteAnswer(answer._id)}
                          >
                            <ion-icon name="trash-outline"></ion-icon> Delete
                          </p>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {/* Edit Modal */}
          <div>
            <div
              className="modal fade"
              id="editModal"
              aria-hidden="true"
              aria-labelledby="exampleModalToggleLabel"
              tabindex="-1"
            >
              <RecordedAnswersAddModal
                characters={characters}
                type="edit"
                answer={activeAnswer}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RecordedAnswers;
